import React, { useEffect, useState } from 'react'

const InputField = (props) => {
  return (
    <input
      type="text"
      className="dome-p2 dome-color-darkest-grey dome-text-w500"
      style={{ border: 'none', width: '100%', borderRadius: 3, background: 'transparent' }}
      {...props}
    />
  )
}

export const SectionHeaderLabel = ({ label, dragHandleProps }) => {
  return (
    <div className="dome-d-flex dome-align-center dome-gap12 dome-flex-1">
      <span {...dragHandleProps}>
        <i className="fa-light fa-grip-vertical fa-sm dome-color-med-grey"></i>
      </span>
      <span className="dome-p2 dome-text-w500 dome-color-darkest-grey">{label}</span>
    </div>
  )
}

export const SectionHeaderInput = ({ initialValue, storeValue, dragHandleProps }) => {
  const [value, setValue] = useState('')

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  const handleKeyDown = (e) => {
    if (e.ctrlKey || e.metaKey) {
      if (e.code === 'KeyS') {
        e.preventDefault()
        e.target.blur()
      }
    }
    if (e.code === 'Enter') e.target.blur()
  }

  return (
    <div className="dome-d-flex dome-align-center dome-gap12 dome-flex-1">
      <span {...dragHandleProps}>
        <i className="fa-light fa-grip-vertical fa-sm dome-color-med-grey"></i>
      </span>
      <InputField
        value={value}
        onKeyDown={handleKeyDown}
        onBlur={() => storeValue(value)}
        onChange={(e) => setValue(e.target.value)}
      />
    </div>
  )
}

export const SectionHeader = ({ children }) => {
  return (
    <div style={{ padding: '6px 12px' }}>
      <div className="dome-d-flex dome-align-center dome-justify-between dome-gap18">{children}</div>
    </div>
  )
}

export const Section = ({ children, className }) => {
  return (
    <div className={className}>
      <div className="dome-d-flex dome-flex-column dome-gap6">{children}</div>
    </div>
  )
}
